import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { withFirebase } from '../../Firebase';
import * as firebase from 'firebase';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { CircularProgress } from '@material-ui/core';
import "../DeleteModalContent.css";

class DeleteCommentContent extends Component {

    render() {
        return (

            <DeleteCommentContentForm {...this.props} />
        );
    }

}

class DeleteCommentContentFormBase extends Component {
    constructor(props) {
        super(props);
        this.state = { deleteLoading: false };
    }

    onAccept = async () => {
        this.setState({ deleteLoading: true })
        let { commentIndex } = this.props
        this.props.deleteIdeaComment(commentIndex)
    }

    onRefuse = () => {
        this.props.onClose()
    }

    render() {
        const { deleteLoading } = this.state
        const { classes } = this.props
        return (
            <>
                <div className="delete-title">
                    Êtes-vous sûr de vouloir supprimer le commentaire ?
              </div>

                <div className="delete-buttons-container">
                    <div className="d-flex justify-content-center position-relative">
                        <button className="delete-accept" onClick={() => this.onAccept()} disabled={deleteLoading}>Oui</button>
                        {deleteLoading && <CircularProgress size={35} className={classes.buttonProgress} />}
                    </div>
                    <div>
                        <button className="delete-refuse" onClick={() => this.onRefuse()}>Non</button>
                    </div>

                </div>
            </>
        );
    }
}

const styles_loader = theme => ({
    root: {
    },
    buttonProgress: {
        color: '#0070A2',
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -20,
        marginLeft: -17,
    },
});

DeleteCommentContentFormBase.propTypes = {
    classes: PropTypes.object.isRequired,
};

const DeleteCommentContentForm = withRouter(withFirebase(withStyles(styles_loader)(DeleteCommentContentFormBase)));


export default DeleteCommentContent;
export { DeleteCommentContentForm };
